import React, { Component } from "react";
import _ from 'lodash';
import {Table, Pagination, Badge, Row, Col, Button} from 'react-bootstrap';
import DoubleScreen from './DoubleScreen'
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default class Inbox extends Component {
  constructor(props){
    super(props)
    this.state = {
      activePage: 1,
      orderBy:'asc',
      auditorbox:props.auditorbox,
      selectedAgents:[],
      startDate: null,
      searched:false,
      monthCycle:[]
    }    
  }
componentWillMount(){
  const {monthCycle, selectedAgents} = this.state;
  var d = new Date();
  d.setDate(d.getDate() - 1);
  this.setState({startDate:d})
  let month = 'Current Month';
  if(!_.isEmpty(monthCycle)){
    month = monthCycle.label
  } 
  let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')
  let obj = {callDate:previousdate, userId:this.props.loginUserName, agentId:selectedAgents.agentId} 
  this.props.action.auditorworkList(obj)
  this.props.action.auditorworkCount({monthCycle:month})
  this.props.action.showAgentQARelated()
}
componentWillReceiveProps(nextProps){ 
  const {monthCycle} = this.state;
 // let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')  
  let obj = {}
  let month = 'Current Month';
  if(!_.isEmpty(monthCycle)){
    month = monthCycle.label
  } 
  if(!_.isNull(this.state.startDate)){
    let date = moment(this.state.startDate).format('YYYY-MM-DD')
    if(!_.isEmpty(this.state.selectedAgents)){
    obj = {callDate:date, userId:this.props.loginUserName, agentId:this.state.selectedAgents.agentId, monthCycle:!_.isEmpty(monthCycle) ? month :''} 
    } else {
      obj = {callDate:date, userId:this.props.loginUserName, monthCycle:!_.isEmpty(monthCycle) ? month :''}
    }
  } else {
    obj = {userId:this.props.loginUserName, monthCycle:!_.isEmpty(monthCycle) ? month :''} 
  }
  
  if(nextProps.submitted === true){
    nextProps.action.auditorworkList(obj)  
    nextProps.action.ResetSubmitted()
    nextProps.action.auditorworkCount({monthCycle:month}) 
  }
  if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
    nextProps.action.auditorworkList(obj)  
    nextProps.action.auditorworkCount({monthCycle:month})    
  }
  if(!_.isEqual(this.props.auditorbox,nextProps.auditorbox)){
    this.setState({auditorbox:nextProps.auditorbox})
  }
}

renderInboxValues = (Rows, startOffset, startCount, Per_Page) => { 
  let returnObj;  
  if(!_.isEmpty(Rows)){  
    returnObj =  _.map(Rows, (obj, i) =>{
      let title = '';
      title = title.concat(obj.regionName, ' - ', obj.centerName, ' - ', obj.clientName, ' - ',obj.processName, ' - ',obj.agentName, ' - ',obj.callDate)
      if(i >= startOffset & startCount < Per_Page){
        startCount++;
            return(<tr onDoubleClick={()=>this.handleDoubleClick(i)}>
            {this.state['showDouble'+i] ? <DoubleScreen closeModal={()=>this.onClose(i)} object={obj} loginUserName={this.props.loginUserName}
            action={this.props.action} title={title}
            /> 
          : null}
            <td>{obj.id}</td>  
            <td>{obj.callDate}</td>
            <td>{obj.startTime}</td>
            <td>{obj.endTime}</td>
            <td>{obj.msisdn}</td>
            <td>{obj.agentName}</td>   
            <td>{obj.regionName}</td>
            <td>{obj.centerName}</td>
            <td>{obj.clientName}</td>
            <td>{obj.processName}</td>   
          </tr>)
      }
    })
  }  
  else {
    returnObj=(<tr><td colSpan="10">No Record Found</td></tr>)
  }
  return returnObj
}
handleDoubleClick = (i) => { 
  this.setState({['showDouble'+i]:true})
}
onClose = (i) => {
  this.setState({['showDouble'+i]:false})
}
handleSelectPagination = (eventKey) => {
  this.setState({
    activePage: eventKey,
  });
}
handleSelectPaginationPrev = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage-1,
  });
}
handleSelectPaginationNext = () => {
  const {activePage} = this.state;
  this.setState({
    activePage: activePage+1,
  });
}
handleSort = (column) => {
  const {orderBy, auditorbox} = this.state
  var data = _.orderBy(auditorbox, [column], orderBy);
  this.setState({auditorbox:data})
  if(orderBy === "asc"){
   this.setState({orderBy:"desc"})
  } else {
   this.setState({orderBy:"asc"})
  }
}
searchData = () =>{
  const{startDate, selectedAgents, monthCycle} = this.state;
  let date = moment(startDate).format('YYYY-MM-DD')
  let month = 'Current Month';
  if(!_.isEmpty(monthCycle)){
    month = monthCycle.label
  } 
  let obj = {
    callDate: startDate ? date : "", 
    userId:this.props.loginUserName, 
    agentId:selectedAgents.agentId,
    monthCycle:!_.isEmpty(monthCycle) ? month :''
  } 
  this.setState({searched:true})
  this.props.action.auditorworkList(obj) 
  this.props.action.auditorworkCount({monthCycle:month})
}
handleChangeStart = (date) =>{
  this.setState({startDate:date, monthCycle:[], searched:false})
}
handleSelectAuditors = (e) =>{
  if(!_.isEqual(this.state.selectedAgents, e)){
   this.setState({selectedAgents:e, searched:false})
  } 
}

resetData = () =>{
  this.setState({selectedAgents:[], startDate: null, searched:false, monthCycle:{'label':'Current Month'}})
  let previousdate = moment().subtract(1, 'days').format('YYYY-MM-DD')
  let obj = {callDate:previousdate, userId:this.props.loginUserName, monthCycle:'Current Month'} 
  this.props.action.auditorworkList(obj)
}
handleSelectMonth = (e) =>{
  this.setState({monthCycle:e, startDate:null, searched:false})
}
render(){
  const{activePage,auditorbox, monthCycle, searched} = this.state;
  const{workCount,agentData} = this.props;  
  const Per_Page=50;  
  let totalPages = 1  
  if(!_.isEmpty(auditorbox)){
    totalPages = Math.ceil(auditorbox.length/Per_Page)
  }
  let items = []; 
  const startOffset = (this.state.activePage-1) * Per_Page;
  let startCount = 0;
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
        {number}
      </Pagination.Item>				
    );
  } 
  let month = moment().format('MMMM-YYYY');
  let previousmonth = moment().subtract(1, 'month').format('MMMM-YYYY')
 return(
   <div>
    {/* {!_.isEmpty(workCount) ?
    <div className='alignRight'>
      <span className='positionAb'>
      <p  className={expand === true ? 'colurcount marginPercent' :  'colurcount'}>      
      <span className='widthInbox'>
      <i className="fas fa-caret-right" onClick={this.handleExpand}></i>&nbsp;
      For {month}</span>
      <span className='relativePos' style={{width:'58px'}}>Target&nbsp;<Badge variant="info">{workCount.total}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'88px'}}>Completed&nbsp;<Badge variant="info">{workCount.completed}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'72px'}}>Pending&nbsp;<Badge variant="info">{workCount.pending}</Badge></span>&nbsp;
      </p>
      {expand === true ?
      <p  className='colurcount' style={{display:'inline-block'}}>      
      <span className='widthInbox'>On {date}</span>
      <span className='relativePos' style={{width:'58px'}}>Target&nbsp;<Badge variant="info">{workCount.total}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'88px'}}>Completed&nbsp;<Badge variant="info">{workCount.completed}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'72px'}}>Pending&nbsp;<Badge variant="info">{workCount.pending}</Badge></span>&nbsp;
      </p> : null}
      {expand === true ?
      <p  className='colurcount' style={{display:'inline-block'}}>      
      <span className='widthInbox'>As on {date}</span>
      <span className='relativePos' style={{width:'58px'}}>Target&nbsp;<Badge variant="info">{workCount.total}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'88px'}}>Completed&nbsp;<Badge variant="info">{workCount.completed}</Badge></span>&nbsp;
      <span className='relativePos' style={{width:'72px'}}>Pending&nbsp;<Badge variant="info">{workCount.pending}</Badge></span>&nbsp;
      </p> : null}
      </span>
    </div> 
  
    // <h6 className='alignRight marginBottom'>
    // <Badge pill variant="info">Target&nbsp;{workCount.total}</Badge>&nbsp;
    // <Badge pill variant="success">Completed&nbsp;{workCount.completed}</Badge>&nbsp;
    // <Badge pill variant="danger">Pending&nbsp;{workCount.pending}</Badge>
    // </h6> 
    : null}*/}
    <div>
    {!_.isEmpty(workCount) && this.props.isPending === false ?
    !_.isEmpty(monthCycle) && monthCycle.label === 'Previous Month' && searched === true  ?
    <Row  className='colurcount'>
      <Col style={{padding:'6px'}}>
          <span><b>For the month {previousmonth}</b></span><br/>          
          <Badge pill variant="info">Target&nbsp;{workCount.monthlyTotal}</Badge>&nbsp;
          <Badge pill variant="success">Completed&nbsp;{workCount.monthlyCompleted}</Badge>&nbsp;
          <Badge pill variant="danger">Pending&nbsp;{workCount.monthlyPending}</Badge>
        </Col>
    </Row> 
    :
      <Row  className='colurcount'>
        <Col className='borderRight'>
        <span><b>For Today</b></span><br/>
        <Badge pill variant="info">Target&nbsp;{workCount.dailyTotal}</Badge>&nbsp;
        <Badge pill variant="success">Completed&nbsp;{workCount.dailyCompleted}</Badge>&nbsp;
        <Badge pill variant="danger">Pending&nbsp;{workCount.dailyPending}</Badge>
        </Col>
        <Col className='borderRight'>
          <span><b>From 1st {month} till date</b></span><br/>          
          <Badge pill variant="info">Target&nbsp;{workCount.total}</Badge>&nbsp;
          <Badge pill variant="success">Completed&nbsp;{workCount.completed}</Badge>&nbsp;
          <Badge pill variant="danger">Pending&nbsp;{workCount.pending}</Badge>
        </Col>
        <Col style={{padding:'6px'}}>
          <span><b>For the month {month}</b></span><br/>          
          <Badge pill variant="info">Target&nbsp;{workCount.monthlyTotal}</Badge>&nbsp;
          <Badge pill variant="success">Completed&nbsp;{workCount.monthlyCompleted}</Badge>&nbsp;
          <Badge pill variant="danger">Pending&nbsp;{workCount.monthlyPending}</Badge>
        </Col>
    </Row> : null}
    <hr/>
    <Row className='clearBoth rowvertical'>
      <Col><b><center>Agent Name</center></b></Col>
      <Col md={2}><Picky keepOpen={false}
            value={this.state.selectedAgents}
            options={agentData ? agentData : []}
            onChange={this.handleSelectAuditors}
            open={false}
            valueKey="agentName"
            labelKey="agentName"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Agent'
            dropdownHeight={600}
          /></Col>
      <Col md={1}><b>Call Date</b></Col>
      <Col md={2}><DatePicker
            selected={this.state.startDate}
            className='myDatePicker'
            selectsStart
            format={'YYYY-mm-dd'}
            showMonthDropdown
            onChange={this.handleChangeStart}
            /></Col>
      <Col md={2}><Picky keepOpen={false}
            value={this.state.monthCycle}
            options={[{'label':'Previous Month'},{'label':'Current Month'}]}
            onChange={this.handleSelectMonth}
            open={false}
            valueKey="label"
            labelKey="label"
            placeholder='Choose Month'
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            dropdownHeight={600}
          />      
      </Col>     
      <Col><Button onClick={this.searchData}>Search</Button></Col>
      <Col><Button onClick={this.resetData}>Reset</Button>
      </Col> 
    </Row>    
    <Table responsive>
      <thead>
        <th>TRANSACTION NO</th>        
        <th>CALL DATE</th>
        <th>START TIME</th>
        <th>END TIME</th>
        <th>MOBILE NO</th>
        <th>AGENT NAME</th>  
        <th>REGION</th>
        <th>CENTER</th>
        <th>CLIENT</th>        
        <th>PROCESS</th>
      </thead>
      <tbody>
        { this.renderInboxValues(auditorbox, startOffset, startCount, Per_Page) }
      </tbody>
    </Table>
    </div>
    {!_.isEmpty(items) ?
    <Pagination>
			<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
			<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
			<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
		  <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
		</Pagination> : null}
    </div>
   )
}
}